import Vue from 'vue'
import MessageBox from '@/components/common/qMsgBox.vue'
const Plugin = {
  install(Vue, options = {}) {

    if (Vue.prototype.$qMsgBox) {
      return
    }

    const plugin = new PluginCore(Vue, options)
    
    Object.defineProperty(Vue.prototype, '$qMsgBox', {
      get: function() {
        const caller = this

        if (caller instanceof Vue) {
           const root = caller.$root

          if (!plugin.context.root) {
            plugin.context.root = root
          }
        }

        return plugin
      }
    })
  }
}

const PluginCore = (Vue, options = {}) => {
  let LoadingIsShow = false;
  const context = {
    root: null,
    componentName: options.componentName || 'qMsgbox',
    vuecom:null,
    vuediv:null,
    componentId:null,
  }

  /**
   * Creates a container for modals in the root Vue component.
   *
   * @param {Vue} parent
   */

  const setCreateDiv = parent => {
    context.root = parent

    const divelement = document.createElement('div')
    document.body.appendChild(divelement)
    
    const vuecomponent = new Vue({
      parent,
      render: h => h(MessageBox)
    }).$mount(divelement)

    const MapResult = vuecomponent.$children.map(compo => {
      const MatchResult = compo.$vnode.tag.match(context.componentName) ?? "none"
      return MatchResult == "none" ? null : compo;
    })

    context.vuediv = divelement;
    context.vuecom = MapResult == null ? null : MapResult[0];
    context.componentId = vuecomponent.$el.id;
  }

  // Router.push할 경우 최상단 div app의 내용이 바뀌면서 안되는듯...
  // virture dom인데 왜...
  const Rerender = () => {

    const old_div = $('#'+context.componentId);
    if(old_div) {
      if(old_div.length > 0) {
        old_div[0].remove();
        context.vuecom.$destroy(context.vuediv);
      }
    }

    setCreateDiv(context.root);   
  }

  const show = (title, msg, buttontype) => {
    Rerender();
    return new Promise((resolve, reject)=> {
      context.vuecom.show(title, msg, buttontype, function(result) {
        resolve(result);
      });
    })
  }

  return {
    context,
    show,
    setCreateDiv
  }
}


export default Plugin